import styled from 'styled-components';

const ContentWrapper = styled.div`
  display: flex;
  line-height: 130%;
  font-size: 1.1em;
  margin: 0.3em 0;
  > div {
    &:first-of-type {
      min-width: 36px;
      width: 36px;
      height: 36px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    &:last-of-type {
      padding: 0 1em 0 1.5em;
      box-sizing: border-box;
    }
  }
  .try-again {
    color: ${props => props.theme.color.primary};
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
  }
`;

export default ContentWrapper;
